<template>
  <div class="app-container">
    <list ref="list" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/cashier/limitflow/list";

export default {
  name: "limitflow",
  mixins: [curdMixins],
  components: {
    list,
  },
  mounted() {},
  methods: {},
};
</script>